import { D as o } from "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import { b as O, c as S, a as g, d as h, M as j } from "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import "react/jsx-runtime";
import "react";
import "react-dom";
import "./index-6a632112.mjs";
import "./themes-5f0b3c3d.mjs";
import "./lineHeights-72d3110c.mjs";
import "./zIndices-d07533f3.mjs";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./index-c8707610.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./superScript-393c70dc.mjs";
import "./disclosure.js";
import "./hTag-40b23797.mjs";
const B = o;
export {
  O as ModalBody,
  S as ModalFooter,
  g as ModalHeader,
  h as ModalMixedStructure,
  j as ModalWindow,
  B as ModalWindowOld
};
